export default {
    en: {
        instagramIsBroken: 'Instagram is broken.',
        letsFixIt: 'Let\s fix it!',
        startBrowsing: 'Start browsing',
        joinTheWaitlist: 'Join the waitlist',
        optimisedForUse: 'Optimised for use.',
        optimised: 'Optimised',
        forYou: 'for you.',
        optimisedDescription: 'While Instagram is designed for mobile, Creatillo is optimised for all devices. Without compromise.',
        darkMode: 'Dark Mode',
        modernUI: 'Modern UI',
        responsive: '100% responsive',
        loveForArt: 'It\'s our love for art',
        bringsUsTogether: 'That brings us together',
        mediaUploader: 'The media uploader',
        mediaUploaderDescription: 'Intuitive. Functional. Easy.',
        featured: 'Featured',
        following: 'Following',
        fresh: 'Fresh',
        feautredDescription: 'A curated feed to discover the best of Creatillo',
        followingDescription: 'Your personal feed to see what your favorite creators are up to',
        freshDescription: 'A chronological feed to help you find new inspiration',
        alwaysVisible: 'Always Visible',
        alwaysVisibleDescription: 'Creatillo is not using complicated algorithms and secret formulas like other media sharing platforms.',
        alwaysVisibleSubdescription: 'Most platforms are not interested in helping you find your audience.It\'s against their business model, as they want you to grow by advertising.',
        areYouReady: 'Are you ready',
        forAnEpicJourney: 'For an epic journey?',
    },
    hu: {
        instagramIsBroken: 'Az Instagram elromlott.',
        letsFixIt: 'Javítsuk meg!',
        startBrowsing: 'Kezdj böngészni',
        joinTheWaitlist: 'Csatlakozz a várolistához',
        optimisedForUse: 'Használatra optimalizálva.',
        optimised: 'szabva.',
        forYou: 'Rád',
        optimisedDescription: 'Míg az Instagram mobilra lett tervezve, addig a Creatillo minden eszközre. Kompromisszum nélkül.',
        darkMode: 'Sötét Téma',
        modernUI: 'Modern felület',
        responsive: '100% reszponzív',
        loveForArt: 'Az alkotás iránti vágy',
        bringsUsTogether: 'Ami összeköt bennünket',
        mediaUploader: 'A média-feltöltő felület',
        mediaUploaderDescription: 'Intuitív. Funkcionális. Egyszerű.',
        featured: 'Kiemelt',
        following: 'Követett',
        fresh: 'Friss',
        feautredDescription: 'Egy válogatott csatorna, hogy felfedezd a legjobbakat a Creatillon',
        followingDescription: 'A személyes csatornád, hogy lásd, kedvenc alkotóid mit csinálnak',
        freshDescription: 'Egy időrend alapú csatorna, hogy új inspirációt találj',
        alwaysVisible: 'Mindig Látható',
        alwaysVisibleDescription: 'A Creatillo nem használ bonyolult algoritmusokat és titkos formulákat, mint más média-megosztó platformok.',
        alwaysVisibleSubdescription: 'A legtöbb platform nem érdekelt abban, hogy segítsen neked megtalálni a közönségedet.Ez szembemegy az üzleti modelljükkel, mivel azt szeretnék, hogy hirdetéssel növeld az elérésedet.',
        areYouReady: 'Készen állsz',
        forAnEpicJourney: 'Egy új kalandra?',
    }
}